import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnacondaComponent } from './simple-icons-anaconda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnacondaComponent ],
    exports:      [ SimpleIconsAnacondaComponent ],
    bootstrap:    []
})
export class SimpleIconsAnacondaModule {}
